module.exports = __webpack_public_path__ + "templates.check-store-stock-modal-d40915d2.html";